import { defineComponent as _defineComponent } from 'vue'
import {
  TUIGlobal,
  TUIStore,
  StoreName,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import { TUIChat, TUIConversation, TUIContact, TUIGroup, TUISearch } from "../TUIKit";
import { ref } from "../TUIKit/adapter-vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Profile from "./Profile.vue";
import { TUICallKit } from "@tencentcloud/call-uikit-vue2";
import Drag from "../TUIKit/components/common/Drag";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const isPC = ref(TUIGlobal.getPlatform() === "pc");
const currentTab = ref("message");
const currentConversationID = ref("");
const showMore = ref(false);
const showCall = ref<boolean>(false);
const isMinimized = ref<boolean>(false);
const dragRef = ref();

TUIStore.watch(StoreName.CONV, {
  currentConversationID: (id: string) => {
    currentConversationID.value = id;
  },
});

const navList = [
  {
    icon: "message",
    name: "message",
    label: "消息",
  },
  {
    icon: "relation",
    name: "relation",
    label: "通讯录",
  },
  {
    icon: "profile",
    name: "profile",
    label: "个人中心",
  },
];

const selectModel = (modelName: string) => {
  currentTab.value = modelName;
};

const closeChat = (closedConversationID: string) => {
  console.log(`conversation ${closedConversationID} has been closed.`);
};

const openShowMore = () => {
  showMore.value = !showMore.value;
};

// beforeCalling：在拨打电话前与收到通话邀请前执行
const beforeCalling = () => {
  showCall.value = true;
};
// afterCalling：结束通话后执行
const afterCalling = () => {
  showCall.value = false;
  isMinimized.value = false;
};
// onMinimized：组件切换最小化状态时执行
const onMinimized = (
  oldMinimizedStatus: boolean,
  newMinimizedStatus: boolean
) => {
  isMinimized.value = newMinimizedStatus;
  dragRef?.value?.positionReset && dragRef?.value?.positionReset();
};

return { __sfc: true,isPC, currentTab, currentConversationID, showMore, showCall, isMinimized, dragRef, navList, selectModel, closeChat, openShowMore, beforeCalling, afterCalling, onMinimized, TUITranslateService, TUIChat, TUIConversation, TUIContact, TUIGroup, TUISearch, Header, Menu, Profile, TUICallKit, Drag }
}

})